import script from "./drawer-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./drawer-v2.vue?vue&type=script&setup=true&lang=js"

import "./drawer-v2.vue?vue&type=style&index=0&id=69e49f97&lang=scss"
import "./drawer-v2.vue?vue&type=style&index=1&id=69e49f97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e49f97"]])

export default __exports__